import React from 'react';

import { BasicRequestParser } from '../constants';
import { AssetOptions } from 'cb-utils/console-entity-models';
import { TriggerSourceDefinition } from '../types';

const AssetCreated: TriggerSourceDefinition = {
  name: AssetOptions.AssetCreated,
  getSummary: () => (
    <div>
      <em>Asset Created</em>
    </div>
  ),
  requestParser: BasicRequestParser,
  conditionOptions: [],
};

export default AssetCreated;
